// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-NtJj","list":"styles_list__jKcNV","item":"styles_item__UHyBh","title":"styles_title__5P1U3","icon":"styles_icon__mrl73"};